module.exports = __webpack_public_path__ + "static/media/container-storage.ef919202.svg";